export default {
  state: {
    company: {
      name: '',
      pricePerLiter: 0
    }
  }
}
